import { Link, useSearchParams } from "react-router-dom"
import { useTypedSelector } from "../../../hooks/useTypedSelector"
import { useActions } from "../../../hooks/useActions"
import { useEffect } from "react"
import { message, Space, Typography, Flex } from "antd"
import { routePath } from "../../../router/types"
import { ArrowLeftOutlined } from "@ant-design/icons"
import CountryFlag from "../../../ui/CountryFlag"
import EditProject from "./EditProject"
const { Title } = Typography

const ProjectDataSettings: React.FC = () => {
  const [searchParams] = useSearchParams()
  const projectId = searchParams.get("projectId")

  const { projectData, error } = useTypedSelector((state) => state.projectDataSettings)
  const { getProject } = useActions()

  useEffect(() => {
    if (!projectId) {
      return
    }

    getProject(projectId)
  }, [projectId])

  useEffect(() => {
    if (error) {
      message.error(error)
    }
  }, [error])

  return (
    <Flex align="center" justify="space-between">
      <Space align="center" size="middle">
        <Link to={`${routePath.PROJECTS}`}>
          <ArrowLeftOutlined />
        </Link>
        <CountryFlag countryCode={projectData.countryCode} />
        <Title level={3} style={{ margin: 0 }}>
          {projectData.title}
        </Title>
      </Space>
      <EditProject />
    </Flex>
  )
}

export default ProjectDataSettings
